// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__Umpgr","row":"default_row__SrU8f"};